module.exports = __webpack_public_path__ + "static/media/report-visual.b9eb27b7.svg";